export interface FriendRequestsState {
    isReady: boolean;
    invitations: any[];
    error?: any;
}

export const FRIEND_REQUESTS_INIT_STATE: FriendRequestsState = {
    isReady         : false,
    invitations     : [],
    error           : null,
};
